import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { getAuthenticated, putAuthenticated } from './api';
import {
  AdminResponse,
  CustomerResponse,
  UpdateCustomerRequest,
} from '../models/contact.models';
import { ProcessStatus } from '../enum/process-status.enum';

export const useGetCustomer = () => {
  const url = `customer`;
  const { isPending, error, data, refetch } = useQuery<CustomerResponse>({
    queryKey: ['customer'],
    queryFn: async () => {
      return getAuthenticated<CustomerResponse>(url);
    },
  });

  return {
    loading: isPending,
    error,
    data: data || undefined,
    isPaidCustomer: isPaidCustomer(data!),
    refetch,
  };
};

const isPaidCustomer = (data: CustomerResponse) => {
  return (
    data?.processStatus === ProcessStatus.PAID_LAND ||
    data?.processStatus === ProcessStatus.PAID_LAND_AND_HOME ||
    data?.processStatus === ProcessStatus.OVERRIDE
  );
};

export const useGetAdmin = () => {
  const url = `admin`;
  const { isPending, error, data, refetch } = useQuery<AdminResponse>({
    queryKey: ['admin'],
    queryFn: async () => {
      return getAuthenticated<AdminResponse>(url);
    },
  });

  return {
    loading: isPending,
    error,
    data: data || undefined,
    refetch,
  };
};

export const useMutateUpdateCustomer = () => {
  const url = `customer`;
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['customer'],
    mutationFn: async (request: UpdateCustomerRequest) => {
      const body = JSON.stringify(request);
      return putAuthenticated<UpdateCustomerRequest>(url, body);
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ['customer'],
      });
    },
  });
};

export interface GetHubspotVisitorIdentificationResponse {
  email: string;
  token: string;
}
export const useGetVisitorId = (sub: string) => {
  const url = `hubspot/visitor-identification`;
  const { isPending, error, data } =
    useQuery<GetHubspotVisitorIdentificationResponse>({
      enabled: !!sub,
      queryKey: ['visitor-id', sub],
      queryFn: async () => {
        return getAuthenticated<GetHubspotVisitorIdentificationResponse>(url);
      },
    });

  return {
    isPending,
    error,
    data: data || undefined,
  };
};
